/**
 * User-facing translation progress copy (single long HTTP request has no server streaming).
 */

/**
 * @param {number} elapsedSec
 * @returns {string}
 */
export function translationStatusPhase(elapsedSec) {
  const s = Math.max(0, Number(elapsedSec) || 0);
  if (s < 3) return 'Sending request to the model';
  if (s < 15) return 'Model is translating your strings';
  if (s < 45) return 'Still processing — typical jobs take 30–60 seconds';
  return 'Still working — large files can take a few minutes';
}

/**
 * @param {object} [options]
 * @param {string} [options.modelLabel]
 * @param {number} [options.stringCount]
 * @param {string} [options.localeLabel]
 * @param {number} [options.stepIndex]
 * @param {number} [options.stepTotal]
 * @param {string} [options.extra]
 * @returns {string}
 */
export function formatTranslationDetail({
  modelLabel,
  stringCount,
  localeLabel,
  stepIndex,
  stepTotal,
  extra
} = {}) {
  const parts = [];

  if (localeLabel && stepIndex != null && stepTotal != null) {
    parts.push(`${localeLabel} (${stepIndex}/${stepTotal})`);
  } else if (localeLabel) {
    parts.push(localeLabel);
  }

  const count = Number(stringCount) || 0;
  if (count > 0) {
    parts.push(`${count} string${count === 1 ? '' : 's'}`);
  }

  if (modelLabel) parts.push(modelLabel);
  if (extra) parts.push(extra);

  return parts.join(' · ');
}
